import { render, staticRenderFns } from "./Pairwise.vue?vue&type=template&id=73203c0c&lang=pug&"
import script from "./Pairwise.vue?vue&type=script&lang=ts&"
export * from "./Pairwise.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports